export default {
  payCancel: 'payment is canceled',
  payError: 'System is busy, please try later'
}
